import { useAuth } from '../context/AuthContext';
import { LogOut, Search, Upload } from 'lucide-react';
import { clsx } from 'clsx';
import type { ChangeEvent } from 'react';

interface HeaderProps {
  onUploadClick: () => void;
  search: string;
  onSearchChange: (value: string) => void;
}

export function Header({ onUploadClick, search, onSearchChange }: HeaderProps) {
  const { logout } = useAuth();

  return (
    <header className="flex flex-wrap items-center gap-4 rounded-2xl bg-surface/60 p-4 supports-backdrop:bg-surface/40 supports-backdrop:backdrop-blur-xl shadow-glass">
      <div>
        <p className="text-sm uppercase tracking-[0.3em] text-surface-foreground/70">NetDrive</p>
        <h1 className="text-2xl font-semibold text-white">我的云匣子</h1>
      </div>

      <div className="flex flex-1 flex-wrap items-center justify-end gap-3">
        <label className="flex items-center gap-2 rounded-full border border-white/10 bg-black/30 px-4 py-2 text-sm text-white/80">
          <Search className="h-4 w-4" />
          <input
            value={search}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
            placeholder="搜索文件、类型、日期"
            className="bg-transparent outline-none placeholder:text-white/40"
          />
        </label>

        <button
          onClick={onUploadClick}
          className={clsx(
            'inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-brand to-accent px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-brand/30 transition-all hover:scale-[1.02]',
          )}
        >
          <Upload className="h-4 w-4" /> 上传
        </button>

        <button
          onClick={logout}
          className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-white/70 hover:text-white"
        >
          <LogOut className="h-4 w-4" />
          退出
        </button>
      </div>
    </header>
  );
}
